import React, { useState } from 'react';
import { DateRangePicker as ADateRangePicker } from 'react-dates';
import moment from 'moment';

interface DateRangePickerProps {
  startDate: string;
  endDate: string;
  /** "Sep 22, 2025" rather than "September 22, 2025", which overflows the input. */
  displayFormat?: string;
  /** Months in the popup. Three is wider than the datasets dialog. */
  numberOfMonths?: number;
  onDatesChanged: ({
    startDate,
    endDate,
  }: {
    startDate: moment.Moment;
    endDate: moment.Moment;
  }) => void;
}

const DateRangePicker = ({
  startDate,
  endDate,
  onDatesChanged,
  // Today's values by default: this renders on `/import_data`, which no flag covers.
  displayFormat = 'LL',
  numberOfMonths = 3,
}: DateRangePickerProps) => {
  const [focusedInput, setFocusedInput] = useState<
    null | 'startDate' | 'endDate'
  >(null);
  return (
    <ADateRangePicker
      startDate={moment(startDate)}
      startDateId="startDate"
      endDate={moment(endDate)}
      endDateId="endDate"
      onDatesChange={onDatesChanged}
      focusedInput={focusedInput}
      onFocusChange={(focusedInput) => {
        setFocusedInput(focusedInput);
      }}
      displayFormat={displayFormat}
      isOutsideRange={() => false}
      numberOfMonths={numberOfMonths}
      minimumNights={30}
      small
    />
  );
};

export default DateRangePicker;
